import Api from '../services/Api';
import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';
import { FornecedorRequest, Response } from './Types';

class FornecedorController {
  public static async Listar(request: FornecedorRequest): Promise<Response> {
    try {
      const response = await Api.post(`api/fornecedor/Listar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async ListarUnico(FornecedorId: number): Promise<Response> {
    try {
      const response = await Api.get(
        `api/fornecedor/ListarUnico/${FornecedorId}`
      );

      const object = response?.data;

      const retorno: Response = {
        StatusCode: response.status,
        Data: object[0],
      };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  /**
   * [27/10/2026] Procura o CPF/CNPJ no cadastro SEM o filtro de fornecedor.
   *
   * O `Listar` acima só devolve quem tem cli_fornecedor = 'S'. Quando ele não acha, a
   * importação de XML precisa saber se o CNPJ existe em OUTRO papel (cliente,
   * transportadora) antes de oferecer "Criar" - senão o Adicionar bate na checagem de
   * CNPJ duplicado da PROC_CLIENTE_ADICIONAR e devolve 500 sem saída.
   *
   * 200 = existe (Data traz o cadastro e as flags). 204 = não existe mesmo, pode criar.
   */
  public static async LocalizarPorCnpj(cpfCnpj: string): Promise<Response> {
    try {
      const response = await Api.post(`api/fornecedor/LocalizarPorCnpj`, {
        CpfCnpj: cpfCnpj,
      });

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  /**
   * [27/10/2026] Liga a flag de fornecedor num cadastro que já existe, e só ela.
   *
   * Não é o `Atualizar` abaixo de propósito: aquele passa pela PROC_CLIENTE_ATUALIZAR,
   * que grava as três flags de papel, e marcaria o fornecedor apagando o cliente.
   */
  public static async MarcarComoFornecedor(cliId: number): Promise<Response> {
    try {
      const response = await Api.put(`api/fornecedor/MarcarComoFornecedor`, {
        CliId: cliId,
      });

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Adicionar(request: FornecedorRequest): Promise<Response> {
    try {
      const response = await Api.post(`api/fornecedor/Adicionar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Atualizar(request: FornecedorRequest): Promise<Response> {
    try {
      console.log('Controller Fornecedor Atualizar');
      console.log(request);

      const response = await Api.put(`api/fornecedor/Atualizar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Excluir(request: FornecedorRequest): Promise<Response> {
    try {
      console.log('Controller Fornecedor Excluir');
      console.log(request);

      const response = await Api.put(`api/fornecedor/Excluir`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }
}

export default FornecedorController;
